module.exports = __webpack_public_path__ + "static/media/mode-53.a5b6f275.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-53.svg
// module id = 1025
// module chunks = 2